import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from "@reduxjs/toolkit";
import themeModeReducer from "./slices/themeModeSlice";
import branchReducer from "../store/slices/branchSlice";
import productReducer from "../store/slices/productSlice";
import loadingSlice from "./slices/loadingSlice";
import toastSlice from "./slices/toastSlice";
import shopSlice from "./slices/shopSlice";
import designPhotoSlice from "./slices/designPhotoSlice";
import tokenSlice from "./slices/tokenSlice";
import disableSlice from "./slices/disableSlice";
import onboardingFeatureSlice from "./slices/onboardingFeatureSlice";
import pageBuilderSlice from "./slices/pageBuilderSlice";
import onboardingSystemSlice from "./slices/onboardingSystemSlice";
const devMode = process.env.NODE_ENV === "development";

const combinedReducer = combineReducers({
  themeMode: themeModeReducer,
  branch: branchReducer,
  product: productReducer,
  loading: loadingSlice,
  toast: toastSlice,
  shop: shopSlice,
  designPhoto: designPhotoSlice,
  token: tokenSlice,
  disable: disableSlice,
  onboardingFeatures: onboardingFeatureSlice,
  pageBuilder: pageBuilderSlice,
  onboardingSystem: onboardingSystemSlice
});

const rootReducer: typeof combinedReducer = (state, action) => {
  return combinedReducer(state, action);
};

export const makeStore = configureStore({
  reducer: rootReducer,
  devTools: devMode,
});

export type RootState = ReturnType<typeof makeStore.getState>; // A global type to access reducers types
export type AppDispatch = typeof makeStore.dispatch; // Type to access dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
